import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { CurrencyViewModel } from '../models/CurrencyViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class CurrencyService {
  /**
   * Mil Rate
   * Gets mil TRYRate
   * @returns CurrencyViewModel Success
   * @throws ApiError
   */
  public static async getMilTryRate(
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<CurrencyViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<CurrencyViewModel>({
      method: 'GET',
      url: `/currency/mil-rate`,
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
